import { render, staticRenderFns } from "./MessageContactModal.vue?vue&type=template&id=3da07c21&scoped=true&"
import script from "./MessageContactModal.vue?vue&type=script&lang=js&"
export * from "./MessageContactModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageContactModal.vue?vue&type=style&index=0&id=3da07c21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da07c21",
  null
  
)

export default component.exports